/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IAccountingCollectionLedger } from 'app/shared/model/accounting-collection-ledger.model';
import { TransactionCategory } from 'app/shared/model/enumerations/transaction-category.model';

export interface IAccountingTransactionBill {
  id?: string;
  billId?: string | null;
  billCategory?: keyof typeof TransactionCategory | null;
  paymentId?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  accountingTransactionId?: string | null;
  collection?: IAccountingCollectionLedger | null;
}

export const defaultValue: Readonly<IAccountingTransactionBill> = {
  active: false,
};
